import { create } from "zustand";
import apiClient from "../helpers/api-client";
import { API_ENDPOINT_ADD_SOURCE } from "src/helpers/endpoint-urls";

const useSourcesStore = create((set: any, get: any) => ({
  addSource: async (params: any = {}) => {
    let hasError = false;

    const formData = new FormData();
    formData.append("params", JSON.stringify(params));
    if (params?.params?.file) {
      formData.append("file", params?.params?.file || "");
    }

    try {
      const result = await apiClient.post(API_ENDPOINT_ADD_SOURCE, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      return {
        error: false,
        success: true,
        data: result,
      };
    } catch (_e) {
      hasError = true;
    }

    return {
      success: !hasError,
      data: [],
      error: hasError,
    };
  },
}));

export default useSourcesStore;
